import React, {useState, useRef, useEffect} from 'react'
import {Column} from '../../../../widgets/TablesComponents/AdvancedTable'
import {useThemeMode} from '../../../../../../_metronic/partials'
import {KTSVG} from '../../../../../../_metronic/helpers'
import { RegistroContactenos } from '../../../models/_models'

interface ColumnDropdownProps {
  columns: Column<RegistroContactenos>[]
  visibleColumnKeys: string[]
  toggleColumn: (key: string) => void
}
const ColumnDropdownContactenos: React.FC<ColumnDropdownProps> = ({
  columns,
  visibleColumnKeys,
  toggleColumn,
}) => {
  const {mode} = useThemeMode()
  const [open, setOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  return (
    <div className='dropdown' ref={dropdownRef}>
      <a
        onClick={() => setOpen(!open)}
        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
      >
        <KTSVG path='/media/icons/duotune/general/gen024.svg' className='svg-icon-1' />
      </a>

      {open && (
        <div
          className='menu menu-sub menu-sub-dropdown show mt-2'
          style={{
            display: 'block',
            position: 'absolute',
            right: 0,
            top: '100%',
            minWidth: '200px',
            overflowY: 'auto',
            zIndex: 10,
          }}
        >
          <div className='fw-bold mb-2 text-center fs-5 px-4 pt-4'>Selecciona columnas</div>
          <div className='d-flex flex-column gap-2 px-4 py-3 ' style={{maxHeight: '250px', overflow: 'auto'}}>
            {columns.map((col) => {
              const id = `checkbox-${col.key as string}`
              return (
                <div
                  className={`form-check form-switch ${
                    mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                  }`}
                  key={col.key as string}
                >
                  <input
                    className='form-check-input'
                    type='checkbox'
                    id={id}
                    checked={visibleColumnKeys.includes(col.key)}
                    onChange={() => toggleColumn(col.key)}
                  />
                  <label className='form-check-label' htmlFor={id}>
                    {col.label}
                  </label>
                </div>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}

export default ColumnDropdownContactenos
